<template>
  <SearchPage
    v-slot="{ hit }"
    endpoint="news"
    :title="entity.title"
    group-by="group"
    :filter-titles="{
      organization: $texts('pressReleaseSender', 'Absender'),
      date: 'Datum',
    }"
  >
    <SearchResultPressRelease v-bind="hit" />
  </SearchPage>
</template>

<script lang="ts" setup>
definePageMeta({
  name: 'news',
  drupalFrontendRoute: true,
  ariaLive: 'off',
  languageMapping: {
    de: '/news',
    en: '/en/news',
    fr: '/fr/derniere-nouvelles',
    it: '/it/notizia',
  },
})

const { entity } = await useDrupalRouteQuery('page')
await renderPageDependencies()
</script>
